<template>
    <!-- 个人资料 -->
    <el-dialog class="wrap" :visible.sync="curUserDetailTableVisible" :before-close="cur_user_detail_dialog_close" :modal-append-to-body="false">
        <div id="wrap">
            <div class="top" :style="{backgroundImage:'url(' + this.ossPath + 'property_top.gif', backgroundRepeat:'repeat-x'}"></div>
            <div id="up">
                <div class="split" :style="{backgroundImage:'url(' + this.ossPath + 'property_bottom.gif', backgroundRepeat:'repeat-y', backgroundPosition:'right'}"></div>
                <div class="xiangqingdiv">
                    <div class="xiangqingline">
                        <span><font>ID</font></span>
                        <span>{{fantasyUserBO.userName}}</span>
                    </div>
                    <div class="xiangqingline">
                        <span><font>昵称</font></span>
                        <span>{{fantasyUserBO.nickName}}</span>
                    </div>
                    <div class="xiangqingline">
                        <span><font>称号</font></span>
                        <span>
                            <TitleBadge
                                v-if="userTitle && userTitle.title"
                                :title="userTitle.title"
                                :short-title="userTitle.shortTitle"
                                :tier="userTitle.tier"
                                :type-name="userTitle.typeName"
                                :evaluate-date="userTitle.evaluateDate"
                                variant="plain"
                                ground="light"
                                :max-chars="14" />
                            <span v-else class="no-title">—</span>
                        </span>
                    </div>
                    <div class="xiangqingline">
                        <span><font>简介</font></span>
                        <span v-if="fantasyUserBO.remark!=null && fantasyUserBO.remark.length > 10">
							{{fantasyUserBO.remark.substring(0,10)}}...
						</span>
						<span v-else>
							{{fantasyUserBO.remark}}
						</span>
                    </div>
                    <div class="xiangqingline">
                        <span><font>上站次数</font></span>
                        <span>{{fantasyUserDetail.logintimes}}</span>
                    </div>
                    <div class="xiangqingline">
                        <span><font>上站时间</font></span>
                        <span>{{landingtime}}</span>
                    </div>
                </div>
                <div class="split" :style="{backgroundImage:'url(' + this.ossPath + 'property_bottom.gif', backgroundRepeat:'repeat-y', backgroundPosition:'right'}"></div>
                <div class="xiangqingdiv">
                    <div class="xiangqingline">
                        <span><font>体力</font></span>
                        <span>{{fantasyUserDetail.strength}}/{{fantasyUserDetail.strengthtop}}</span>
                    </div>
                    <div class="xiangqingline">
                        <span><font>疲劳</font></span>
                        <span>{{fantasyUserDetail.exhaustion}}/{{fantasyUserDetail.exhaustionTop}}</span>
                    </div>
					<div class="xiangqingline">
						<span><font>经验</font></span>
						<span>{{ expProgressText }}</span>
					</div>
					<div class="xiangqingline">
						<span><font>升级</font></span>
						<span>{{ expRemainText }}</span>
					</div>
					<div class="xiangqingline">
						<span><font>等级</font></span>
						<span>{{fantasyUserDetail.level}}</span>
					</div>
					<div class="xiangqingline">
						<span><font>金钱</font></span>
						<span>{{fantasyUserDetail.money}}</span>
					</div>
				</div>
			<div class="userface" v-if="null != this.fantasyUserHeader">
				<div id="header_div">
					<div id="header_type" ref="header_type">
					</div>
					<div id="eye_type" ref="eye_type">
					</div>
					<div id="mouth_type" ref="mouth_type">
					</div>
					<div id="hair_type" ref="hair_type">
					</div>
				</div>
			</div>
		</div>
		<div class="middle" :style="{backgroundImage:'url(' + this.ossPath + 'property_middle.gif', backgroundRepeat:'repeat-x'}"></div>
		<div id="down">
			<div id="columns" class="clearfix">
				<div class="column">
					<div class="propline">
						<div class="name">容貌</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.rongmao/fantasyUserProperty.rongmaotop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.rongmao}}/{{fantasyUserProperty.rongmaotop}}</div>
							</div>
						</div>
					</div>
					<div class="propline">
						<div class="name">毅力</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.yili/fantasyUserProperty.yilitop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.yili}}/{{fantasyUserProperty.yilitop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">臂力</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.bili/fantasyUserProperty.bilitop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.bili}}/{{fantasyUserProperty.bilitop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">悟性</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.wuxing/fantasyUserProperty.wuxingtop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.wuxing}}/{{fantasyUserProperty.wuxingtop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">热情</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.reqing/fantasyUserProperty.reqingtop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.reqing}}/{{fantasyUserProperty.reqingtop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">嗓音</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.sangyin/fantasyUserProperty.sangyintop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.sangyin}}/{{fantasyUserProperty.sangyintop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">魄力</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.poli/fantasyUserProperty.politop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.poli}}/{{fantasyUserProperty.politop}}</div>
							</div>
								
						</div>
					</div>
				</div>
				<div class="column">
					<div class="propline">
						<div class="name">反应</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.fanying/fantasyUserProperty.fanyingtop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.fanying}}/{{fantasyUserProperty.fanyingtop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">音乐</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.yinyue/fantasyUserProperty.yinyuetop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.yinyue}}/{{fantasyUserProperty.yinyuetop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">美术</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.meishu/fantasyUserProperty.meishutop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.meishu}}/{{fantasyUserProperty.meishutop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">文学</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.wenxue/fantasyUserProperty.wenxuetop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.wenxue}}/{{fantasyUserProperty.wenxuetop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">表演</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.biaoyan/fantasyUserProperty.biaoyantop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.biaoyan}}/{{fantasyUserProperty.biaoyantop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">口才</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.koucai/fantasyUserProperty.koucaitop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.koucai}}/{{fantasyUserProperty.koucaitop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">感受</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.ganshou/fantasyUserProperty.ganshoutop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.ganshou}}/{{fantasyUserProperty.ganshoutop}}</div>
							</div>
								
						</div>
					</div>
				</div>
				<div class="column">
					<div class="propline">
						<div class="name">创意</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.chuangyi/fantasyUserProperty.chuangyitop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.chuangyi}}/{{fantasyUserProperty.chuangyitop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">经营</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.jingying/fantasyUserProperty.jingyingtop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.jingying}}/{{fantasyUserProperty.jingyingtop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">人缘</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.renyuan/fantasyUserProperty.renyuantop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.renyuan}}/{{fantasyUserProperty.renyuantop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">道德</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.daode/fantasyUserProperty.daodetop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.daode}}/{{fantasyUserProperty.daodetop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">科技</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.keji/fantasyUserProperty.kejitop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.keji}}/{{fantasyUserProperty.kejitop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">游戏</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.youxi/fantasyUserProperty.youxitop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.youxi}}/{{fantasyUserProperty.youxitop}}</div>
							</div>
								
						</div>
					</div>
					<div class="propline">
						<div class="name">影视</div>
						<div class="propers">
							<div :style="{width:fantasyUserProperty.yingshi/fantasyUserProperty.yingshitop*100 + '%'}">
								<div class="points">{{fantasyUserProperty.yingshi}}/{{fantasyUserProperty.yingshitop}}</div>
							</div>
								
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bottom" :style="{backgroundImage:'url(' + this.ossPath + 'property_bottom.gif', backgroundRepeat:'repeat-x'}"></div>
	</div>
    </el-dialog>
</template>

<script>
import {postRequest} from '../../utils/api'
import {getRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
import TitleBadge from '../common/TitleBadge'
export default {
  name: 'curUserDetail',
  components: { TitleBadge },
  props:{
    curUserDetailTableVisible: {
      type: Boolean,
      default: false
    },
    fantasyUserBO: Object,
    fantasyUserDetail: Object,
    fantasyUserProperty: Object,
  },
  data() {
    return {
		editingNickName: false,
		newNickName: "",
		fantasyUserHeader: {},
		// 当前被查看者的称号（他人视角，只含公开字段：名称/短名/档位/类别/评定日期）
		userTitle: null
    };
  },
  computed: {
    landingtime: function () {
        let landingtime = 0;
        let sec = this.fantasyUserDetail.landingtime;
        let min = Math.floor(sec / 60);
        if (min < 1) {
            landingtime = sec % 60 + "秒";
        } else if (min < 60) {
            landingtime = min + "分" + sec % 60 + "秒";
        } else {
            landingtime = Math.floor(min/60) + "小时" + min%60 + "分" + sec % 60 + "秒";
        }
        return landingtime;
    },
    // 本级经验进度（与底部经验条同口径：升级后从 0 起算，升级动作的溢出自动计入）；
    // levelExpTop=0 为满级；派生字段缺省时回退旧口径，兼容前后端发布过渡期
    expProgressText() {
        const d = this.fantasyUserDetail || {};
        if (d.levelExpTop === 0) return '已满级';
        if (d.levelExp == null || d.levelExpTop == null) return d.exp != null ? d.exp : '-';
        return d.levelExp + '/' + d.levelExpTop;
    },
    expRemainText() {
        const d = this.fantasyUserDetail || {};
        if (d.levelExpTop === 0) return '—';
        if (d.levelExp == null || d.levelExpTop == null) return d.nextexp != null ? d.nextexp : '-';
        return '还需' + Math.max(0, d.levelExpTop - d.levelExp);
    }
  },
  mounted: function () {
      this.showFantasyUserHeader();
  },
  beforeDestroy: function() {
  },
  watch: {
    // 资料页会被复用来查看不同玩家，必须在 userId 变化时重新拉称号，
    // 否则会出现「点 A 看的是 A 的称号，再点 B 还显示 A 的称号」。
    fantasyUserBO: {
      handler(newVal) {
        this.loadUserTitle(newVal && newVal.id)
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 拉取被查看者的称号。
     * 注意 old 字段 fantasyUserDetail.chenghao 是死字段（有列有 Mapper 但全库无人写入），
     * 从那里读永远是空——这也是资料页称号长期显示空白的原因。
     */
    loadUserTitle: function(userId) {
      this.userTitle = null;
      if (!userId) return;
      getRequest('/user/title/getUserTitle', { userId: String(userId) }).then(resp => {
        if (resp.status == 200 && resp.data && 200 == resp.data.status) {
          this.userTitle = resp.data.data || null;
        }
      }, () => {});
    },
    // 玩家形象
    showFantasyUserHeader: function(){
        this.fantasyUserHeader = {};
        this.loading = true;
        // 玩家形象
        getRequest('/user/userHeader/getUserHeaderInfo', {
            userId: this.fantasyUserBO.id
        }).then(resp=> {
            this.loading = false;
            if (resp.status == 200) {
            //成功
            var respData = resp.data;
            //alert(JSON.stringify(data))
            //alert(data.result == false)
            if (200 == respData.status) {
                if (null != respData.data) {
                    this.fantasyUserHeader = respData.data;
                    this.$refs.mouth_type.style.backgroundImage = "url(" + this.ossPath + this.fantasyUserHeader.mouthUrl + ")";
                    this.$refs.header_type.style.backgroundImage = "url(" + this.ossPath + this.fantasyUserHeader.faceUrl + ")";
                    this.$refs.eye_type.style.backgroundImage = "url(" + this.ossPath + this.fantasyUserHeader.eyeUrl + ")";
                    this.$refs.hair_type.style.backgroundImage = "url(" + this.ossPath + this.fantasyUserHeader.hairUrl + ")";
                }
            } else {
                Message.error(data.returnMessage);
            }
            } else {
            //失败
            Message.error('查询玩家形象失败');
            }
        }, resp=> {
            Message.error('查询玩家形象异常');
        });
    },
    cur_user_detail_dialog_close(){
      this.$emit("cur_user_detail_dialog_close");
	},
	changeNickName() {
		if (this.newNickName == "" || this.newNickName == this.fantasyUserBO.nickName) {
			this.editingNickName = false;
			return ;
		} else if (this.newNickName.length > 9) {
			Message.warning("昵称长度过长，请修改。");
			this.editingNickName = false;
			return ;
		}
		postRequest('/user/user/changeNickName', {
			nickName: this.newNickName
		}).then(resp=> {
			if (resp.status == 200) {
			//成功
            var respData = resp.data;
            if (200 == respData.status) {
				this.$store.commit('user/SET_FANTASY_USER', respData.data);
				Message.success(respData.message);
			} else {
                Message.error(respData.message);
			}
			} else {
			//失败
			Message.error('用户非法⊙﹏⊙∥!');
			}
		}, resp=> {
			Message.error('用户非法⊙﹏⊙∥!');
		});
		this.editingNickName = false;
	}
  }
}
</script>

<style>
    /* 无称号时留一个弱化的占位符，不要用「普通市民」之类的默认称号去顶 */
    .xiangqingline .no-title {
        color: #bbb;
    }
    .curUserDetail .el-dialog {
		width:60%;
        border-radius: 8px;
        overflow: hidden;
    }
    .curUserDetail .el-dialog__headerbtn {
        top: 5px;
        right: 5px;
    }
    .curUserDetail .el-dialog__body {
		padding: 0;
		margin: 0;
    }
    .curUserDetail .wrap {
		margin:0 auto;
	}
	.curUserDetail #wrap {
		margin:0 auto;
		width:100%;
	}
	.top {
		width:100%;
		height:23px;
	}
	#up {
		height: auto;
		min-height: 111px;
		background-color: #9990c5;
		padding: 6px 0;
		overflow: hidden;
	}
	.middle {
		width:100%;
		height:12px;
		position: relative;
	}
	#down {
        /* margin-top: 12px; */
		height:147px;
		background-color: #9990c5;
		position: relative;
	}
	.bottom {
		width:100%;
		height:8px;
	}
	#columns {
		margin:0 auto;
		width:100%;
		height:145px;
    	position: absolute; left: 5%; top: 5%; right: 0; bottom: 0;
	}
	.column {
		margin:0 5px;
		width:30%;
		height:140px;
		float:left;
	}
	.clearfix {
		zoom:1;	
	}
	.clearfix:after {
		display:block;
		visibility:hidden;
		font-size:0;
		line-height:0;
		clear:both;
		content:"";
	}
	.propline>div {
		vertical-align:middle;
		font-size: 14px;
		height:16px;
		line-height:16px;
		display: inline-block;
	}
	.name {
		font-weight: bolder;
	}
	.propers {
		background-color: #cfd0c8;
		width:100px;
		height:16px;
		position: relative;
	}
	.propers>div {
		background-color: #ffc808;
		height:100%;
    	position: absolute; left: 0; top: 0; right: 0; bottom: 0;
	}
	.points {
    	position: absolute; left: 0; top: 0; right: 0; bottom: 0;
    	text-align:center;
    	width:100px;
		font-size: 12px;
		line-height:16px;
	}
	.split {
		height:100px;
		width:10px;
		margin-left:5%;
		/* background: url("../../assets/fantasy/property_bottom.gif") repeat-y right; */
		float:left;
	}
	.xiangqingdiv {
		margin:0px 5px;
		float:left;
		width:30%;
	}
	/* 每行「标签 + 值」：值这一格可收缩（min-width:0），
	   否则窄屏上长称号/长昵称会直接顶出紫底，而不是安分地出省略号 */
	.xiangqingline {
		display: flex;
		align-items: baseline;
	}
	.xiangqingline > span:first-child {
		flex: 0 0 auto;
	}
	.xiangqingline > span:last-child {
		flex: 1 1 auto;
		min-width: 0;
		/* 长称号在这里被裁成省略号，而不是顶着紫底边缘画到容器外 */
		overflow: hidden;
	}
	.xiangqingline span font {
		font-weight: bolder;
		font-size:14px;
		line-height:18px;
		font-family: Microsoft YaHei;
		margin-right: 5px;
	}
	
	#up .userface {
		float: right;
		margin: 0px 10px;
	}
	#up .userface img {
		width:77px;
		height:96px;
	}
	#up .nickName {
		width: 100px;
	}
	
	#header_div {
		width:64px;
		height:80px;
	background-size:64px 80px;
	-moz-background-size:64px 80px;
		position:relative;
	}

	#header_div #hair_type {
		width:64px;
		height:80px;
		background-size:64px 80px;
		background-repeat:no-repeat;
		position:absolute;
	}

	#header_div #eye_type {
		width:64px;
		height:80px;
		background-size:64px 80px;
		background-repeat:no-repeat;
		position:absolute;
	}

	#header_div #mouth_type {
		width:64px;
		height:80px;
		background-size:64px 80px;
		background-repeat:no-repeat;
		position:absolute;
	}

	#header_div #header_type {
		width:64px;
		height:80px;
		background-size:64px 80px;
		background-repeat:no-repeat;
		position:absolute;
	}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
    .curUserDetail .el-dialog {
        width: 92% !important;
        margin-top: 2vh !important;
    }
    #up {
        height: auto;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        padding: 6px 0;
    }
    .split {
        display: none;
    }
    .xiangqingdiv {
        width: 48%;
        margin: 0;
        padding: 0 4px;
        box-sizing: border-box;
        /* flex 子项默认 min-width:auto，不加这句就会被内容撑宽、把紫底顶破 */
        min-width: 0;
    }
    .xiangqingline span font {
        font-size: 12px;
        line-height: 16px;
    }
    .xiangqingline span {
        font-size: 12px;
    }
    #up .userface {
        float: none;
        margin: 4px auto;
        width: 100%;
        text-align: center;
    }
    #header_div {
        margin: 0 auto;
    }
    #down {
        height: auto;
        padding: 8px 4px;
    }
    #columns {
        position: static;
        height: auto;
    }
    .column {
        width: 50%;
        height: auto;
        margin: 0;
        padding: 2px 6px;
        box-sizing: border-box;
    }
    .propline {
        display: flex;
        align-items: center;
        margin: 2px 0;
    }
    .propline>div {
        font-size: 12px;
        height: 16px;
        line-height: 16px;
        display: block;
    }
    .name {
        width: 38px;
        flex-shrink: 0;
    }
    .propers {
        width: auto;
        flex: 1;
        height: 16px;
        min-width: 0;
    }
    .propers>div {
        height: 100%;
    }
    .points {
        width: 100px;
        font-size: 10px;
        line-height: 16px;
        white-space: nowrap;
    }
}
</style>